import { render, staticRenderFns } from "./MailToSearch.vue?vue&type=template&id=53f06f40&scoped=true&"
import script from "./MailToSearch.vue?vue&type=script&lang=js&"
export * from "./MailToSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f06f40",
  null
  
)

export default component.exports